import type { SubscriberKey, WithSubscription } from "./types";

export const withSubscription = <T extends object>(
    anyObject: T,
    subscriberKey: SubscriberKey
): WithSubscription<T> => ({
    ...anyObject,
    subscriberKey
});